import type { RequestElements } from "alova";

function CustomFetchAdapter<T = any>(elements: RequestElements) {
  const { url, type, data, headers } = elements;

  const controller = new AbortController();

  const isFormData = data instanceof FormData;
  const isUrlSearchParams = data instanceof URLSearchParams;

  const requestHeaders: Record<string, string> = {
    ...headers,
  };

  // Jangan set application/json untuk FormData atau URLSearchParams
  if (data && !isFormData && !isUrlSearchParams) {
    requestHeaders["Content-Type"] =
      requestHeaders["Content-Type"] ?? "application/json";
  }

  const fetchPromise = fetch(url, {
    method: type,
    body:
      isFormData || isUrlSearchParams
        ? data
        : data
          ? JSON.stringify(data)
          : undefined,
    headers: requestHeaders,
    signal: controller.signal,
  });

  /**
   * Cache response supaya fetch() hanya dilakukan sekali.
   */
  const responsePromise = fetchPromise;

  /**
   * Body Response hanya boleh dibaca sekali.
   *
   * Kita cache hasil parsing-nya supaya kalau Alova
   * memanggil response() lebih dari sekali tidak terjadi:
   *
   * "body stream already read"
   */
  let bodyPromise: Promise<T>;

  bodyPromise = (async () => {
    const response = await responsePromise;

    const text = await response.text();

    let body: any = null;

    if (text) {
      try {
        body = JSON.parse(text);
      } catch {
        body = text;
      }
    }

    if (!response.ok) {
      const error = new Error(
        body?.message || `HTTP error! status: ${response.status}`,
      );

      (error as any).status = response.status;
      (error as any).data = body;

      throw error;
    }

    return body as T;
  })();

  return {
    async response(): Promise<T> {
      return bodyPromise;
    },

    async headers() {
      const response = await responsePromise;
      return response.headers;
    },

    abort() {
      controller.abort();
    },
  };
}

export default CustomFetchAdapter;
